@if(!isProduction()){
    <div class="fixed top-4 right-4 z-50 rounded-full bg-slate-800/10 px-3 py-1 text-[11px] font-semibold uppercase tracking-[0.18em] text-slate-700 border border-slate-200 shadow-sm print:hidden">
        Entorno de desarrollo
    </div>
}
<app-sync-status-badge></app-sync-status-badge>
<app-document-device-alert></app-document-device-alert>
<div class="flex h-screen bg-[#F8FAFC] font-sans text-slate-900 overflow-hidden">

    <input type="checkbox" id="sidebar-toggle" class="peer hidden" />

    @if (mobileMenuOpen()) {
    <div class="fixed inset-0 z-40 bg-black/40 md:hidden" (click)="closeMobileMenu()"></div>
    }

    <aside class="fixed inset-y-0 left-0 z-50 bg-white border-r border-slate-200 flex flex-col transition-all duration-300 ease-in-out
                w-64
                md:static md:translate-x-0 md:w-64 md:peer-checked:w-20 shadow-sm print:hidden"
        [class.-translate-x-full]="!mobileMenuOpen()"
        [class.translate-x-0]="mobileMenuOpen()">

        @if (isSuperAdmin && selectedCompanyName) {
        <div
            class="px-4 py-2 bg-amber-50 border-b border-amber-100 text-xs text-amber-700 flex items-center justify-between gap-2 overflow-hidden">
            <span class="truncate font-medium" title="{{ selectedCompanyName }}">{{ selectedCompanyName }}</span>
            <button (click)="switchCompany(); closeMobileMenu()" routerLink="/companies"
                class="shrink-0 text-amber-600 hover:text-amber-800 underline whitespace-nowrap">cambiar</button>
        </div>
        }
        <div class="h-20 flex items-center px-7 border-b border-slate-100 overflow-hidden">
            <label for="sidebar-toggle" (click)="closeMobileMenu()" class="cursor-pointer p-2 -ml-2 hover:bg-slate-50 rounded-lg">
                <span class="text-xl text-center" title="menu">
                    <img src="/icons/bars.svg" class="min-w-6 min-h-6" alt="menu">
                </span>
            </label>

            <a routerLink="/" (click)="closeMobileMenu()" class="ml-4 flex flex-col transition-all duration-300 whitespace-nowrap overflow-hidden
                   peer-checked:block md:block md:peer-checked:hidden">
                <span class="text-lg font-bold tracking-tight text-slate-800 flex items-center">
                    <img src="logo.svg" class="h-10 w-10">
                    <span>
                        <p>ERP</p>
                        <span class="block text-[10px] text-slate-400 font-bold uppercase tracking-tighter -mt-1">
                            v{{ appVersion() }}
                        </span>
                    </span>
                </span>

            </a>
        </div>

        <nav class="flex-1 p-4 space-y-2 overflow-y-auto overflow-x-hidden">

            @if(!isSuperAdmin || selectedCompanyName){
            <a routerLink="/" (click)="closeMobileMenu()"
                class="flex items-center px-3 py-2.5 rounded-md hover:bg-slate-50 text-slate-600 hover:text-slate-900 transition-all group"
                routerLinkActive="bg-slate-50 text-slate-900 shadow" [routerLinkActiveOptions]="{ exact: true }">
                <span class="text-xl min-w-6 text-center" title="Panel General">
                    <img src="/icons/dashboard.svg" alt="Panel General" class="w-6 h-6">
                </span>
                <span class="ml-6 font-medium whitespace-nowrap inline md:peer-checked:hidden">
                    Panel General
                </span>
            </a>
            @for (menu of menus; track menu.name) {

            @if (menu.subMenu) {
            <details class="group/menu list-none" #rla="routerLinkActive" routerLinkActive [attr.open]="rla.isActive ? '' : null">
                <summary [class.bg-slate-50]="rla.isActive" [class.text-slate-900]="rla.isActive"
                    [class.shadow]="rla.isActive"
                    class="relative flex items-center px-3 py-2.5 rounded-md hover:bg-slate-50 text-slate-600 hover:text-slate-900 transition-all cursor-pointer list-none [&::-webkit-details-marker]:hidden">

                    <a [routerLink]="menu.url" (click)="closeMobileMenu()" class="text-xl min-w-6 text-center" [title]="menu.name">
                        <img [src]="'/icons/' + menu.icon" [alt]="menu.name" class="w-6 h-6">
                    </a>

                    <span
                        class="ml-6 font-medium whitespace-nowrap inline md:peer-checked:hidden flex-1">
                        {{menu.name}}
                    </span>

                    <svg class="w-4 h-4 transition-transform duration-200 group-open/menu:rotate-180 block md:peer-checked:hidden"
                        fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
                    </svg>
                </summary>

                <div class="mt-1 ml-9 space-y-1 block md:peer-checked:hidden">
                    @for (sub of menu.subMenu; track sub.name) {
                    <a [routerLink]="sub.url" (click)="closeMobileMenu()"
                        class="flex items-center px-3 py-2 text-sm rounded-md text-slate-500 hover:bg-slate-50 hover:text-slate-900 transition-all"
                        routerLinkActive="bg-slate-50 text-slate-900" [routerLinkActiveOptions]="{ exact: true }">
                        <span class="mr-3 w-1.5 h-1.5 rounded-full bg-slate-300" routerLinkActive="bg-slate-500"
                            [routerLinkActiveOptions]="{ exact: true }"></span>
                        {{ sub.name }}
                    </a>
                    }
                </div>
            </details>
            } @else {
            <a [routerLink]="menu.url" (click)="closeMobileMenu()"
                class="flex items-center px-3 py-2.5 rounded-md hover:bg-slate-50 text-slate-600 hover:text-slate-900 transition-all group"
                routerLinkActive="bg-slate-50 text-slate-900 shadow">
                <span class="text-xl min-w-6 text-center" [title]="menu.name">
                    <img [src]="'/icons/' + menu.icon" [alt]="menu.name" class="w-6 h-6">
                </span>
                <span
                    class="ml-6 font-medium whitespace-nowrap inline md:peer-checked:hidden">
                    {{menu.name}}
                </span>
            </a>
            }
            }
            }@else{
            <a routerLink="companies" (click)="closeMobileMenu()"
                class="flex items-center px-3 py-2.5 rounded-md hover:bg-slate-50 text-slate-600 hover:text-slate-900 transition-all group"
                routerLinkActive="bg-slate-50 text-slate-900 shadow">
                <span class="text-xl min-w-6 text-center" title="Compañías">
                    <img src="/icons/building.svg" alt="Compañías" class="w-6 h-6">
                </span>
                <span
                    class="ml-6 font-medium whitespace-nowrap inline md:peer-checked:hidden">
                    Compañías
                </span>
            </a>
            <a routerLink="backups" (click)="closeMobileMenu()"
                class="flex items-center px-3 py-2.5 rounded-md hover:bg-slate-50 text-slate-600 hover:text-slate-900 transition-all group"
                routerLinkActive="bg-slate-50 text-slate-900 shadow">
                <span class="text-xl min-w-6 text-center" title="Copias de seguridad">
                    <img src="/icons/cubes.svg" alt="Copias de seguridad" class="w-6 h-6">
                </span>
                <span
                    class="ml-6 font-medium whitespace-nowrap inline md:peer-checked:hidden">
                    Copias de seguridad
                </span>
            </a>
            }

        </nav>

        <section class="flex items-center p-4 border-t border-slate-100">
            <div class="relative inline-block shrink-0">

                <input type="checkbox" id="settings-menu-toggle" class="peer/settings hidden" />

                <label for="settings-menu-toggle"
                    class="cursor-pointer flex items-center justify-center w-10 h-10 rounded-xl bg-slate-50 border border-slate-200 text-slate-500 transition-all duration-300 hover:bg-slate-50 hover:text-slate-900 hover:border-slate-200 hover:shadow-inner">
                    <svg xmlns="http://www.w3.org/2000/svg"
                        class="w-6 h-6 transition-transform duration-700 peer-checked/settings:rotate-90" fill="none"
                        viewBox="0 0 24 24" stroke="currentColor">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                            d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" />
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                            d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                    </svg>
                </label>

                <label for="settings-menu-toggle" class="hidden peer-checked/settings:block fixed inset-0 z-40"></label>

                <div
                    class="absolute bottom-full left-0 mb-4 w-52 origin-bottom-left bg-white/95 backdrop-blur-sm border border-slate-200 divide-y divide-slate-100 rounded-xl shadow-2xl
                    invisible opacity-0 translate-y-2 transition-all duration-200
                    peer-checked/settings:visible peer-checked/settings:opacity-100 peer-checked/settings:translate-y-0 z-50">

                    <div class="absolute w-full h-4"></div>

                    <div class="py-1">
                        <a (click)="openProfileForm(); closeMobileMenu()"
                            class="group/item flex items-center px-4 py-2.5 text-sm text-slate-700 hover:bg-slate-200 transition-colors cursor-pointer">
                            Mi perfil
                        </a>
                        <a routerLink="settings" (click)="closeMobileMenu()"
                            class="group/item flex items-center px-4 py-2.5 text-sm text-slate-700 hover:bg-slate-200 transition-colors">
                            Configuración
                        </a>
                        <a routerLink="/company" (click)="closeMobileMenu()"
                            class="group/item flex items-center px-4 py-2.5 text-sm text-slate-700 hover:bg-slate-200 transition-colors">
                            Compañía
                        </a>
                        @if (canManageRoles) {
                        <a routerLink="/roles" (click)="closeMobileMenu()"
                            class="group/item flex items-center px-4 py-2.5 text-sm text-slate-700 hover:bg-slate-200 transition-colors">
                            Roles y permisos
                        </a>
                        <a routerLink="/users-list" (click)="closeMobileMenu()"
                            class="group/item flex items-center px-4 py-2.5 text-sm text-slate-700 hover:bg-slate-200 transition-colors">
                            Usuarios
                        </a>
                        }
                    </div>

                    <div class="py-1">
                        <a (click)="logout(); closeMobileMenu()"
                            class="flex items-center px-4 py-2.5 text-sm text-red-600 hover:bg-red-50 font-medium transition-colors cursor-pointer">
                            <svg class="w-4 h-4 mr-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                    d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" />
                            </svg>
                            Cerrar sesión
                        </a>
                    </div>
                </div>
            </div>
            <span class="m-auto text-sm font-medium text-slate-700 whitespace-nowrap truncate
                         inline md:peer-checked:hidden">
                {{ currentUserName }}
            </span>
        </section>

    </aside>

    <div class="flex-1 flex flex-col min-w-0 bg-[#F8FAFC]">

        <div class="md:hidden flex items-center gap-3 h-14 px-4 border-b border-slate-200 bg-white shadow-sm print:hidden">
            <button type="button" (click)="toggleMobileMenu()" title="menu"
                class="p-2 -ml-2 hover:bg-slate-50 rounded-lg">
                <img src="/icons/bars.svg" class="w-6 h-6" alt="menu">
            </button>
            <a routerLink="/" (click)="closeMobileMenu()" class="flex items-center gap-2">
                <img src="logo.svg" class="h-8 w-8">
                <span class="font-bold text-slate-800">ERP</span>
            </a>
        </div>

        <main class="flex-1 overflow-auto p-8">
            <div class="max-w-7xl mx-auto">
                <router-outlet />
            </div>
        </main>

    </div>
</div>